(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["polar-scratch-discount-popup"]) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-polar-scratch-popup]');

    const getFallbackOfferValue = (code) => {
      if (String(code).trim().toUpperCase() === 'POLAR50') return '$50 off';
      return 'your discount';
    };

    const getUnlockedStatus = (status, code, offerValue) => {
      const trimmedStatus = String(status || '').trim();
      const trimmedCode = String(code || '').trim();
      const codeText = trimmedCode || 'your code';

      if (!trimmedStatus || trimmedStatus === 'Code unlocked. Tap to copy.') {
        return `Use code ${codeText} for ${offerValue}. Tap to copy.`;
      }

      return trimmedStatus;
    };

    const ensurePrizeValue = (root, offerValue) => {
      const prize = root.querySelector('.polar-scratch__prize');
      const codeButton = root.querySelector('.polar-scratch__code');
      const label = prize?.querySelector('span');

      if (!prize || !codeButton) return;

      if (label && label.textContent.trim().toLowerCase() === 'unlocked code') {
        label.textContent = 'You unlocked';
      }

      if (!prize.querySelector('.polar-scratch__value')) {
        const value = document.createElement('strong');
        value.className = 'polar-scratch__value';
        value.textContent = offerValue;
        codeButton.insertAdjacentElement('beforebegin', value);
      }
    };

    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dialog = root.querySelector('.polar-scratch__dialog');
      const closeButtons = root.querySelectorAll('[data-polar-scratch-close]');
      const canvas = root.querySelector('[data-polar-scratch-canvas]');
      const card = root.querySelector('[data-polar-scratch-card]');
      const copyButtons = root.querySelectorAll('[data-polar-scratch-copy]');
      const codeButton = root.querySelector('.polar-scratch__code');
      const status = root.querySelector('[data-polar-scratch-status]');
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const designMode = root.dataset.designMode === 'true';
      const delay = Math.max(Number(root.dataset.delay || 2), 0) * 1000;
      const threshold = Math.max(Number(root.dataset.revealPercent || 45), 1) / 100;
      const storageKey = root.dataset.storageKey || 'polar_scratch_discount';
      const frequencyHours = Math.max(Number(root.dataset.frequencyHours || 72), 0);
      const scratchLabel = card?.dataset.scratchLabel || 'Scratch to unlock';
      const discountCode = String(codeButton?.dataset.code || copyButtons[0]?.dataset.code || codeButton?.textContent || '').trim();
      const offerValue = String(root.dataset.offerValue || getFallbackOfferValue(discountCode)).trim();
      const unlockedStatus = getUnlockedStatus(root.dataset.unlockedStatus, discountCode, offerValue);
      const copiedStatus = root.dataset.copiedStatus || 'Code copied.';
      const previewParameter = 'polar_scratch_preview';
      const previewMode = (() => {
        if (designMode) return true;

        try {
          const params = new URLSearchParams(window.location.search);
          return params.get(previewParameter) === '1';
        } catch (error) {
          return false;
        }
      })();
      let ctx = null;
      let drawing = false;
      let unlocked = false;
      let pointerId = null;

      if (!dialog || !canvas || !card) return;

      ensurePrizeValue(root, offerValue);

      const getLocalSuppressedUntil = () => {
        try {
          return Number(window.localStorage.getItem(storageKey) || 0);
        } catch (error) {
          return 0;
        }
      };

      const getCookieSuppressedUntil = () => {
        const encodedKey = `${encodeURIComponent(storageKey)}=`;
        const cookies = document.cookie ? document.cookie.split('; ') : [];
        const cookie = cookies.find((item) => item.indexOf(encodedKey) === 0);

        if (!cookie) return 0;

        return Number(decodeURIComponent(cookie.slice(encodedKey.length)) || 0);
      };

      const getSuppressedUntil = () => Math.max(getLocalSuppressedUntil(), getCookieSuppressedUntil());

      const suppress = () => {
        if (previewMode || frequencyHours <= 0) return;
        const expiresAt = Date.now() + frequencyHours * 60 * 60 * 1000;
        const maxAge = Math.max(Math.ceil((expiresAt - Date.now()) / 1000), 0);

        try {
          window.localStorage.setItem(storageKey, String(expiresAt));
        } catch (error) {
          void error;
        }

        document.cookie = `${encodeURIComponent(storageKey)}=${encodeURIComponent(String(expiresAt))}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
      };

      const shouldOpen = () => {
        if (previewMode) return true;
        return Date.now() > getSuppressedUntil();
      };

      const lockScroll = () => document.body.classList.add('polar-scratch-is-open');
      const unlockScroll = () => document.body.classList.remove('polar-scratch-is-open');

      const burstConfetti = () => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const shell = root.querySelector('.polar-scratch__shell') || dialog;
        const existing = shell.querySelector('.polar-scratch__confetti');
        const colors = ['#71d4d0', '#ffd86b', '#ffffff', '#0d9b9a', '#ff8f70'];
        const burst = document.createElement('div');

        if (existing) existing.remove();

        burst.className = 'polar-scratch__confetti';

        for (let index = 0; index < 38; index += 1) {
          const piece = document.createElement('span');
          const angle = (Math.PI * 2 * index) / 38 + Math.random() * 0.5;
          const distance = 92 + Math.random() * 158;
          const x = Math.cos(angle) * distance;
          const y = Math.sin(angle) * distance - 42;

          piece.className = 'polar-scratch__confetti-piece';
          piece.style.setProperty('--x', `${x.toFixed(1)}px`);
          piece.style.setProperty('--y', `${y.toFixed(1)}px`);
          piece.style.setProperty('--r', `${Math.round(Math.random() * 540 - 270)}deg`);
          piece.style.setProperty('--color', colors[index % colors.length]);
          piece.style.animationDelay = `${Math.random() * 110}ms`;
          piece.style.width = `${6 + Math.random() * 5}px`;
          piece.style.height = `${9 + Math.random() * 8}px`;
          burst.appendChild(piece);
        }

        shell.appendChild(burst);
        window.setTimeout(() => burst.remove(), 1400);
      };

      const drawOverlay = () => {
        const rect = canvas.getBoundingClientRect();
        const width = Math.max(Math.round(rect.width), 1);
        const height = Math.max(Math.round(rect.height), 1);
        const dpr = Math.max(window.devicePixelRatio || 1, 1);

        canvas.width = Math.round(width * dpr);
        canvas.height = Math.round(height * dpr);

        ctx = canvas.getContext('2d');
        if (!ctx) return;

        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

        const gradient = ctx.createLinearGradient(0, 0, width, height);
        gradient.addColorStop(0, '#8fded9');
        gradient.addColorStop(0.48, '#f1f7f6');
        gradient.addColorStop(1, '#ffd86b');
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, width, height);

        ctx.globalAlpha = 0.18;
        ctx.fillStyle = '#051822';
        for (let x = -width; x < width * 2; x += 26) {
          ctx.save();
          ctx.translate(x, 0);
          ctx.rotate(-0.72);
          ctx.fillRect(0, 0, 10, height * 2);
          ctx.restore();
        }
        ctx.globalAlpha = 1;

        ctx.fillStyle = '#051822';
        ctx.font = '900 18px system-ui, -apple-system, BlinkMacSystemFont, sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(scratchLabel.toUpperCase(), width / 2, height / 2);
        ctx.globalCompositeOperation = 'destination-out';
      };

      const open = () => {
        if (!shouldOpen()) return;

        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }

        lockScroll();
        suppress();
        window.requestAnimationFrame(drawOverlay);
      };

      const close = () => {
        suppress();
        if (dialog.open && typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
          unlockScroll();
        }
      };

      const reveal = () => {
        if (unlocked) return;
        unlocked = true;
        root.classList.add('is-unlocked');
        if (status) status.textContent = unlockedStatus;
        burstConfetti();
        suppress();
      };

      const getPoint = (event) => {
        const rect = canvas.getBoundingClientRect();
        return {
          x: event.clientX - rect.left,
          y: event.clientY - rect.top,
        };
      };

      const scratch = (event) => {
        if (!ctx || !drawing || unlocked) return;
        const point = getPoint(event);
        ctx.beginPath();
        ctx.arc(point.x, point.y, 24, 0, Math.PI * 2);
        ctx.fill();
      };

      const getClearedRatio = () => {
        if (!ctx) return 0;
        const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        let clear = 0;
        let total = 0;

        for (let index = 3; index < pixels.length; index += 64) {
          total += 1;
          if (pixels[index] < 20) clear += 1;
        }

        return total ? clear / total : 0;
      };

      canvas.addEventListener('pointerdown', (event) => {
        if (unlocked) return;
        drawing = true;
        pointerId = event.pointerId;
        canvas.setPointerCapture(pointerId);
        scratch(event);
      });

      canvas.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointerId) return;
        scratch(event);
        if (getClearedRatio() >= threshold) reveal();
      });

      const finishScratch = (event) => {
        if (event.pointerId !== pointerId) return;
        drawing = false;
        pointerId = null;
        if (getClearedRatio() >= threshold) reveal();
      };

      canvas.addEventListener('pointerup', finishScratch);
      canvas.addEventListener('pointercancel', finishScratch);
      closeButtons.forEach((button) => button.addEventListener('click', close));

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      });

      dialog.addEventListener('close', unlockScroll);
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        close();
      });

      const handleViewportChange = () => {
        if (dialog.open) window.requestAnimationFrame(drawOverlay);
      };

      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', handleViewportChange);
      } else if (typeof mobileQuery.addListener === 'function') {
        mobileQuery.addListener(handleViewportChange);
      }

      copyButtons.forEach((button) => {
        button.addEventListener('click', async () => {
          const code = button.dataset.code || '';
          if (!code) return;

          try {
            await window.navigator.clipboard.writeText(code);
            if (status) status.textContent = copiedStatus;
          } catch (error) {
            if (status) status.textContent = code;
          }
        });
      });

      window.setTimeout(open, delay);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
